// @core/api/endpoints/payment/list_payment_methods_by_legal_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPaymentMethodsByLegalEntityResponse,
} from '../../../types/payment';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/payment';

/**
 * List payment methods attached to a legal entity
 * Returns active PaymentMethodDetail entries attached to the given LegalEntity, either directly via PaymentMethodDetail.legal_entity or transitively through BillingAccount.legal_entity_ref. Used by document/contract rendering to pick the bank block for a signature party. Filter by currency to narrow the bank account used for a specific contract.
 */
export async function ListPaymentMethodsByLegalEntity(
  legalEntityId: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPaymentMethodsByLegalEntityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-methods/by-legal-entity/:legalEntityId`;
  requestPath = requestPath.replace(':legalEntityId', encodeURIComponent(legalEntityId));
  const requestOptions = options;
  return client.get<ListPaymentMethodsByLegalEntityResponse>(requestPath, { ...requestOptions, params });
}
